import React from 'react';
import useIsOnline from '../../hooks/useIsOnline/useIsOnline';
import Snackbar from '../Snackbar/Snackbar';
import useRoomState from '../../hooks/useRoomState/useRoomState';

export default function ReconnectingNotification() {
  const roomState = useRoomState();
  const isOnline = useIsOnline();
  const isReconnecting = roomState === 'reconnecting';
  const shouldOpen = isReconnecting || !isOnline;

  const variant = isOnline ? 'warning' : 'error';
  const headline = isOnline ? 'Reconectando chamada:' : 'Sem internet:';
  const message = isOnline
    ? 'Detectamos instabilidade na chamada. Tentando reconectar automaticamente.'
    : 'Sua internet parece indisponivel. O video pode ficar em branco ate a conexao voltar.';

  return <Snackbar variant={variant} headline={headline} message={message} open={shouldOpen} />;
}
